export const campaignType = {
    SMS: 0,
    Load: 1
}
export const tagType = {
    Sent: 1,
    WithFallOut: 2
}
